<template>
  <div class="wrapper">
    <div class="title">立即打开</div>
    <div @click="downloadApp" class="bold downloadapp">{{_channel}}</div>
    <div @click="openApp" class="bold openapp">打开小鲲车服</div>
    <div @click="closePopup" class="bold cancelBtn">取消</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      _channel: ''
    }
  },
  props: ['mlink'],
  created () {
    this._channel = tuhu.device.android ? '去应用市场下载' : '去App Store下载'
  },
  methods: {
    closePopup() {
      this.$emit('cancelChange', {})
    },
    downloadApp() {
      Ta.ta('event', 'mw_download_btn_click', {
        channel: tuhu.orderChannel || 'kH5'
      })
      if (tuhu.device.isWeixin) {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.TuHu.android'
      } else if (tuhu.device.ios) {
        window.location.href = 'https://itunes.apple.com/cn/app/tu-hu-yang-che-5fen-qian-xi-che/id943708006?mt=8'
      } else {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.TuHu.android'
      }
      this.$emit('cancelChange', {})
    },
    openApp() {
      Ta.ta('event', 'mw_openapp_btn_click', {
        channel: tuhu.orderChannel || 'kH5'
      })
      if (this.mlink && !tuhu.device.isWeixin) {
        window.location.href = this.mlink
      }
      this.$emit('cancelChange', {})
    }
  }
}
</script>
<style lang="less">
  .mw_centerMiddle {
    width: 100%;
    .th_content-wrap {
      width: 13.5rem;
      background-color: #ffffff;
      border-radius: 5px;
      .th_content {
        border-radius: 5px;
        .wrapper{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          div{
            width: 100%;
            height: 2.1rem;
            display: flex;
            justify-content: center;
            align-items: center
          }
          .title{
            color: #333333;
          }
          .bold{
            font-size: .8rem;
            color: #333333;
            font-weight: 500;
            border-top: 1px solid #EEEEEE;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// lib/pages/_search/mwtemplate.vue